__turbopack_context__.v({
  "active": "-JXO-W_active",
  "division": "-JXO-W_division",
  "price": "-JXO-W_price",
  "priceHeading": "-JXO-W_priceHeading",
  "priceUnit": "-JXO-W_priceUnit",
  "productCard": "-JXO-W_productCard",
  "title": "-JXO-W_title",
});
